import { Alert } from 'antd';
import { ReactNode } from 'react';
import CardDefault from '../../../components/shared/CardDefault';

interface Props {
  name: string | ReactNode;
  isFree?: boolean
}

const CardSuccess = ({ name, isFree }: Props) => {
  return (
    <CardDefault className='bg-white'>
      <div className='text-lg font-medium text-black'>
        {name}
      </div>

      <div className='text-base text-gray-500'>
        Parabéns pela sua compra! 🎉🛒 Espero que você esteja satisfeito(a) com o que adquiriu. Seja um produto, serviço ou experiência, aproveite ao máximo!
      </div>

      {isFree && (
        <Alert
          className='mt-4'
          message="Esta transação é apenas uma validação do seu cartão. O valor será estornado automaticamente em seguida, sem qualquer custo para você."
          type="info"
          showIcon
        />
      )}
    </CardDefault>
  )
};

export default CardSuccess;
